<template>
    <div class="vrm-custom-widget-form__parameter__placeholder">
        <div :class="{ 'sg-error': hasErrors }">{{ $t('custom_widgets.no_selected_devices') }}</div>
        <span>{{ $t('custom_widgets.please_add_parameter') }}</span>
    </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class YAxisParameterPlaceholder extends Vue {
    hasErrors = false;

    vrmValidate() {
        this.hasErrors = true;
        return false;
    }
}
</script>
